import {Label} from '@primer/react'

import labelStyles from '../../stack-section/EntryStatusLabel.module.css'
import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'

export function MergeConflictsLabel({state}: {state?: RebaseState}) {
  if (state !== RebaseState.MergeConflicts) return null

  return (
    <Label variant="danger" className={labelStyles.solid}>
      Merge conflicts
    </Label>
  )
}
